export const PlayerQuantityStep:(wizardData:any,editParams:any,playerProductData:any,wizardId:string)=>{name:string, detail:string}|null = (wizardData:any,_editParams:any,_playerProductData:any,_wizardId) => {//https://github.com/Stahls/stahls-wizards/blob/e899b31ecb5341c348b9eb66cc01e2574516b15c/src/letters-numbers/steps/player-quantity.js#L13
  if (wizardData.txtQTY) {
    return {
        "name": "Quantity",
        "detail": (wizardData.txtQTY as number[]).reduce((sum, value, _index) => sum+value) + " items"
    };
  }
  return null
}
